import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, DialogActions, Button, Typography, Box } from '@mui/material';
import { Form, Formik } from 'formik';

import { CreateAccount } from 'entities/Account';

import { FormTextField } from 'shared/components/Form';

import { CloseIcon, LockIcon } from 'icons';
import { createProfileSchemaValidationSchema } from './lib';

import { useDialogStyles } from '../styles';

interface PrivateDialogProps {
  open: boolean;
  loading: boolean;
  handleClose(e?: any): void;
  onSubmit(data: CreateAccount): void;
  initValues: CreateAccount;
}

const ProfileDialog = (props: PrivateDialogProps) => {
  const { open, initValues, loading, onSubmit, handleClose } = props;

  const { classes: dialogClasses } = useDialogStyles();

  return (
    <Formik initialValues={initValues} validationSchema={createProfileSchemaValidationSchema} onSubmit={onSubmit} enableReinitialize>
      {({ values, dirty, isValid }) => {
        return (
          <Form>
            <Dialog open={open} onClose={handleClose}>
              <Box mt={4} mb={4}>
                <DialogTitle className={dialogClasses.title}>
                  <LockIcon />
                </DialogTitle>
                <IconButton onClick={handleClose} className={dialogClasses.closeBtn} size="large">
                  <CloseIcon />
                </IconButton>
                <Box mb={2} mt={2}>
                  <DialogContent className={dialogClasses.content}>
                    <Typography variant="h3">Oops!</Typography>
                    <Typography variant="subtitle1">Before you proceed to the next step, you need to enter your Nickname first</Typography>
                    <Box mb={2}>
                      <FormTextField name="nickName" placeholder="@nickname" value={values.nickName} fullWidth />
                    </Box>
                    <Box mb={2}>
                      <FormTextField name="email" placeholder="Email" value={values.email} fullWidth />
                    </Box>
                  </DialogContent>
                </Box>
                <Box ml={8} mr={8}>
                  <DialogActions className={dialogClasses.actions}>
                    <Button
                      fullWidth
                      className={dialogClasses.actionBtn}
                      type="submit"
                      disabled={!dirty || !isValid || loading}
                      variant="contained"
                      onClick={() => onSubmit(values)}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Box>
              </Box>
            </Dialog>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ProfileDialog;
